import { CarouselButtons, Stack, XStack, useCarousel } from '@my/ui'
import { ArticleCarouselProps } from './article-carousel-props'
import { ArticleCard } from '../article-card'

export const ArticleCarousel = ({ articles, imagePriority }: ArticleCarouselProps) => {
  const carousel = useCarousel()
  return (
    <Stack
      className="overflow-x-hidden"
      position="relative"
      w="100%"
      ref={carousel.emblaRef as any}
    >
      <XStack height="auto" mx="$-2">
        {articles.map((item, index) => (
          <Stack key={item.id} w={300} $gtMd={{ w: '33.33%' }} pb="$2" px="$2">
            <ArticleCard
              {...item}
              wrapperStyle={{
                flex: 1,
              }}
              imagePriority={index < 4 && imagePriority}
            />
          </Stack>
        ))}
      </XStack>
      <CarouselButtons carousel={carousel} />
    </Stack>
  )
}
